import * as Sentry from '@sentry/browser'
import { getAuth, signOut as firebaseSignOut } from 'firebase/auth'
import { removeLocalStorageToken } from 'store/localStorage'
import { getClientInstance } from 'client'

let signingOut = false

const signOut = () => {
  if (signingOut) return
  signingOut = true
  Sentry.setUser(null)
  removeLocalStorageToken()
  getClientInstance()?.clearStore()
  const auth = getAuth()
  if (auth.currentUser) {
    firebaseSignOut(auth)
  }

  window.location.reload()
}
export default signOut
